import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

const previewDocument = async (templatePath, data, fileName) => {
  const blob = await getBlob(templatePath, data);
  if(blob) {
    saveAs(blob, fileName);
  }
};

const getDocZip = async (templatePath, data) => {
  const response = await fetch(templatePath);
  const templateArrayBuffer = await response.arrayBuffer();
  const zip = new PizZip(templateArrayBuffer);
  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true
  });
  doc.setData(data);
  try {
    doc.render();
    return doc.getZip();
  } catch (error) {
    console.error('error:', error);
    return null;
  }
};

const getBlob = async (templatePath, data) => {
  const zip = await getDocZip(templatePath, data);
  if (!zip) return null;
  return zip.generate({
    type: 'blob',
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  });
};

const injectImageAtDocumentTop = (zip, base64Png, title) => {
  zip.file('word/media/otif_chart.png', base64Png, { base64: true });

  const relsFile = zip.file('word/_rels/document.xml.rels');
  if (relsFile) {
    let relsContent = relsFile.asText();
    const newRel = `<Relationship Id="rIdOtifChart999" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="media/otif_chart.png"/>`;
    relsContent = relsContent.replace('</Relationships>', newRel + '</Relationships>');
    zip.file('word/_rels/document.xml.rels', relsContent);
  }

  const titleXml = `<w:p>
    <w:pPr><w:jc w:val="center"/></w:pPr>
    <w:r><w:rPr><w:b/><w:sz w:val="28"/><w:szCs w:val="28"/></w:rPr>
      <w:t>${escapeXml(title)}</w:t>
    </w:r>
  </w:p>`;

  const imageXml = `<w:p>
    <w:r>
      <w:drawing>
        <wp:inline xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing"
                   distT="0" distB="0" distL="0" distR="0">
          <wp:extent cx="9144000" cy="5400000"/>
          <wp:effectExtent l="0" t="0" r="0" b="0"/>
          <wp:docPr id="999" name="OTiF Chart"/>
          <wp:cNvGraphicFramePr>
            <a:graphicFrameLocks xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" noChangeAspect="1"/>
          </wp:cNvGraphicFramePr>
          <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
            <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
              <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
                <pic:nvPicPr>
                  <pic:cNvPr id="999" name="otif_chart.png"/>
                  <pic:cNvPicPr/>
                </pic:nvPicPr>
                <pic:blipFill>
                  <a:blip r:embed="rIdOtifChart999"
                          xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"/>
                  <a:stretch><a:fillRect/></a:stretch>
                </pic:blipFill>
                <pic:spPr>
                  <a:xfrm><a:off x="0" y="0"/><a:ext cx="9144000" cy="5400000"/></a:xfrm>
                  <a:prstGeom prst="rect"><a:avLst/></a:prstGeom>
                </pic:spPr>
              </pic:pic>
            </a:graphicData>
          </a:graphic>
        </wp:inline>
      </w:drawing>
    </w:r>
  </w:p>`;

  const spacerXml = `<w:p><w:r><w:t xml:space="preserve"> </w:t></w:r></w:p>`;

  const docFile = zip.file('word/document.xml');
  if (docFile) {
    let docContent = docFile.asText();
    const inject = titleXml + spacerXml + imageXml + spacerXml;

    const markerIdx = docContent.indexOf('OTIF_CHART_MARKER');
    if (markerIdx !== -1) {
      const paraStart = docContent.lastIndexOf('<w:p ', markerIdx);
      const paraEnd = docContent.indexOf('</w:p>', markerIdx) + '</w:p>'.length;
      docContent = docContent.slice(0, paraStart) + inject + docContent.slice(paraEnd);
    } else {
      // fallback: inject đầu document
      docContent = docContent.replace('<w:body>', '<w:body>' + inject);
    }

    zip.file('word/document.xml', docContent);
  }
};

const injectImagesAtDocumentTop = (zip, images) => {
  images.forEach(({ base64, fileName }) => {
    zip.file(`word/media/${fileName}`, base64, { base64: true });
  });

  const relsFile = zip.file('word/_rels/document.xml.rels');
  if (relsFile) {
    let relsContent = relsFile.asText();
    const newRels = images
      .map(
        ({ rId, fileName }) =>
          `<Relationship Id="${rId}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="media/${fileName}"/>`
      )
      .join('');
    relsContent = relsContent.replace(
      '</Relationships>',
      newRels + '</Relationships>'
    );
    zip.file('word/_rels/document.xml.rels', relsContent);
  }

  const allXml = images
    .map(({ title, rId }, i) => {
      const docPrId = 900 + i;
      const titleXml = `<w:p>
    <w:pPr><w:jc w:val="center"/></w:pPr>
    <w:r><w:rPr><w:b/><w:sz w:val="28"/><w:szCs w:val="28"/></w:rPr>
      <w:t>${escapeXml(title)}</w:t>
    </w:r>
  </w:p>`;

      const imageXml = `<w:p>
    <w:r>
      <w:drawing>
        <wp:inline xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing"
                   distT="0" distB="0" distL="0" distR="0">
          <wp:extent cx="9144000" cy="5400000"/>
          <wp:effectExtent l="0" t="0" r="0" b="0"/>
          <wp:docPr id="${docPrId}" name="OTiF Chart ${i + 1}"/>
          <wp:cNvGraphicFramePr>
            <a:graphicFrameLocks xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" noChangeAspect="1"/>
          </wp:cNvGraphicFramePr>
          <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
            <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
              <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
                <pic:nvPicPr>
                  <pic:cNvPr id="${docPrId}" name="otif_chart_${i}.png"/>
                  <pic:cNvPicPr/>
                </pic:nvPicPr>
                <pic:blipFill>
                  <a:blip r:embed="${rId}"
                          xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"/>
                  <a:stretch><a:fillRect/></a:stretch>
                </pic:blipFill>
                <pic:spPr>
                  <a:xfrm><a:off x="0" y="0"/><a:ext cx="9144000" cy="5400000"/></a:xfrm>
                  <a:prstGeom prst="rect"><a:avLst/></a:prstGeom>
                </pic:spPr>
              </pic:pic>
            </a:graphicData>
          </a:graphic>
        </wp:inline>
      </w:drawing>
    </w:r>
  </w:p>`;

      const spacerXml = `<w:p><w:r><w:t xml:space="preserve"> </w:t></w:r></w:p>`;
      return titleXml + spacerXml + imageXml + spacerXml;
    })
    .join('');

  const docFile = zip.file('word/document.xml');
  if (docFile) {
    let docContent = docFile.asText();
    const markerIdx = docContent.indexOf('OTIF_CHART_MARKER');
    if (markerIdx !== -1) {
      const paraStart = docContent.lastIndexOf('<w:p ', markerIdx);
      const paraEnd =
        docContent.indexOf('</w:p>', markerIdx) + '</w:p>'.length;
      docContent =
        docContent.slice(0, paraStart) + allXml + docContent.slice(paraEnd);
    } else {
      docContent = docContent.replace('<w:body>', '<w:body>' + allXml);
    }
    zip.file('word/document.xml', docContent);
  }
};

const buildTableXml = (headers, rows) => {
  let tableXml = `
    <w:tbl>
        <w:tblPr>
            <w:tblW w:w="5000" w:type="pct"/>
            <w:tblBorders>
                <w:top w:val="single" w:sz="4" w:space="0" w:color="000000"/>
                <w:left w:val="single" w:sz="4" w:space="0" w:color="000000"/>
                <w:bottom w:val="single" w:sz="4" w:space="0" w:color="000000"/>
                <w:right w:val="single" w:sz="4" w:space="0" w:color="000000"/>
                <w:insideH w:val="single" w:sz="4" w:space="0" w:color="000000"/>
                <w:insideV w:val="single" w:sz="4" w:space="0" w:color="000000"/>
            </w:tblBorders>
        </w:tblPr>
        <w:tr>
    `;

  headers.forEach((header, index) => {
    const isLastColumn = index === headers.length - 1;
    const width = isLastColumn ? 4000 : 2000;
    tableXml += `
        <w:tc>
            <w:tcPr>
                <w:tcW w:w="${width}" w:type="dxa"/>
                <w:shd w:fill="D3D3D3"/> <!-- Màu nền xám cho header -->
            </w:tcPr>
            <w:p><w:r><w:t>${header.headerText}</w:t></w:r></w:p>
        </w:tc>
        `;
  });

  tableXml += `</w:tr>`;

  rows?.forEach(row => {
    tableXml += `<w:tr>`;
    headers.forEach((header, index) => {
      let cellContent = row[header.value];
      const isFirstColumn = index === 0;
      const bgColor = isFirstColumn ? 'D3D3D3' : '';
      const isValidNumber = !isNaN(cellContent) && !isNaN(parseFloat(cellContent)) && cellContent.toString().trim() === parseFloat(cellContent).toString();
      if (isValidNumber && parseFloat(cellContent) > 0) {
        cellContent = `<w:r><w:rPr><w:color w:val="FF0000"/></w:rPr><w:t>${cellContent}</w:t></w:r>`;
      } else {
        var content = escapeXml(cellContent);
        content = content ?? '';
        cellContent = `<w:r><w:t>${content}</w:t></w:r>`;
      }

      tableXml += `
            <w:tc>
                <w:tcPr><w:tcW w:w="2000" w:type="dxa"/>
                ${bgColor ? `<w:shd w:fill="${bgColor}"/>` : ''}
                </w:tcPr>
                <w:p>${cellContent}</w:p>
            </w:tc>
        `;
    });
    tableXml += `</w:tr>`;
  });

  tableXml += `</w:tbl>`;
  return tableXml;
};

const escapeXml = str => {
  if (typeof str === 'string') {
    return str.replace(/[&<>"']/g, match => {
      switch (match) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        case "'":
          return '&apos;';
        default:
          return match;
      }
    });
  }
  return str;
};

const injectHtmlChunkAtDocumentTop = (zip, htmlContent) => {
  const fullHtml = `<!DOCTYPE html>
<html><head><meta charset="utf-8"/></head>
<body>${htmlContent}</body></html>`;
  zip.file('word/htmlChunk1.html', fullHtml);

  const relsFile = zip.file('word/_rels/document.xml.rels');
  if (relsFile) {
    let relsContent = relsFile.asText();
    const newRel = `<Relationship Id="rIdHtmlChunk1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/aFChunk" Target="htmlChunk1.html"/>`;
    relsContent = relsContent.replace('</Relationships>', newRel + '</Relationships>');
    zip.file('word/_rels/document.xml.rels', relsContent);
  }

  const contentTypesFile = zip.file('[Content_Types].xml');
  if (contentTypesFile) {
    let ctContent = contentTypesFile.asText();
    if (!ctContent.includes('htmlChunk1.html')) {
      const override = `<Override PartName="/word/htmlChunk1.html" ContentType="text/html"/>`;
      ctContent = ctContent.replace('</Types>', override + '</Types>');
      zip.file('[Content_Types].xml', ctContent);
    }
  }

  const altChunkXml = `<w:altChunk r:id="rIdHtmlChunk1" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"/>`;

  const docFile = zip.file('word/document.xml');
  if (docFile) {
    let docContent = docFile.asText();
    const markerIdx = docContent.indexOf('OTIF_CHART_MARKER');
    if (markerIdx !== -1) {
      const paraStart = docContent.lastIndexOf('<w:p ', markerIdx);
      const paraEnd = docContent.indexOf('</w:p>', markerIdx) + '</w:p>'.length;
      docContent = docContent.slice(0, paraStart) + altChunkXml + docContent.slice(paraEnd);
    } else {
      docContent = docContent.replace('<w:body>', '<w:body>' + altChunkXml);
    }
    zip.file('word/document.xml', docContent);
  }
};

export { previewDocument, buildTableXml, escapeXml, getBlob, getDocZip, injectImageAtDocumentTop, injectImagesAtDocumentTop, injectHtmlChunkAtDocumentTop };
